import { render, staticRenderFns } from "./VerifyTwoFA.vue?vue&type=template&id=94c857c4&scoped=true&"
import script from "./VerifyTwoFA.vue?vue&type=script&lang=js&"
export * from "./VerifyTwoFA.vue?vue&type=script&lang=js&"
import style0 from "./VerifyTwoFA.vue?vue&type=style&index=0&id=94c857c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c857c4",
  null
  
)

export default component.exports